import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ApiHttpService } from './apihttp.service';
import { APIType } from 'src/app/config/constant';
import { StorageService } from './storage.service';
import { GamingHouserPlayer } from '../model/api';


export const GAMING_DEPOSIT_FEE = 'GAMINGDEPOSIT_KIOSK'
export const GAMING_WITHDRAWAL_FEE = 'GAMINGWITHDRAWAL_KIOSK'

export interface GamingHouse {
  id: string,
  code: "TIG" | "PG" | "AW" | "FML" | "IL" | "UG",
  min: string,
  max: string,
  name: string,
  logo: string,
  status_kiosk: "ACTIVE" | "INACTIVE",
  is_pin_required: "YES" | "NO",
  kiosk_min_deposit: string,
  kiosk_max_deposit: string,
  kiosk_min_withdraw: string,
  kiosk_max_withdraw: string,
  is_card_available: "YES" | "NO",
  has_deposit_pin: "YES" | "NO",
  has_withdraw_pin: "YES" | "NO"
};
export type ExtendedGamingHouse = GamingHouse & { has_pin: boolean, pin_digit: number, hasWithdraw: boolean, hasDeposit: boolean }

export const GAMING_ENDPOINTS: {
  GAMING_HOUSES: APIType<{ session: string }, GamingHouse[]>,
  PROCESS_GAMING_CARD: APIType<{ session: string, gamingHouse: string, token: string, pin: string, amount: number, type: 'Deposit' | 'Withdraw', fee: number, vat: number, cardValue: string, isQR: 1 | 0 }, {
    transactionId: string,
    withdrawableBalance: string,
    balance: string,
  }>
  VALIDATE_VIA_CARD: APIType<{ session: string, gamingHouse: string, cardValue: string, pin: string, isQR: 1 | 0 }, GamingHouserPlayer>
} = {
  GAMING_HOUSES: { method: 'getGamingHouses', params: { session: 'P01', }, },
  PROCESS_GAMING_CARD: { method: 'getGamingHouses', params: { session: 'P01', gamingHouse: 'P02', token: 'P03', pin: 'P04', amount: 'P05', type: 'P06', fee: 'P07', vat: 'P08', cardValue: 'P09', isQR: 'P10' }, },
  VALIDATE_VIA_CARD: { method: 'validateGamingCard', params: { session: 'P01', gamingHouse: 'P02', cardValue: 'P03', pin: 'P04', isQR: 'P05' } }
}

@Injectable({
  providedIn: 'root',
})
export class GamingService {
  constructor(public api: ApiHttpService, public storage: StorageService) {
  }
  private isDark: Subject<boolean> = new BehaviorSubject<boolean>(false);
  private page: Subject<string> = new BehaviorSubject<string>("");
  private category: Subject<string> = new BehaviorSubject<string>("");
  private reset: Subject<boolean> = new BehaviorSubject<boolean>(false);
  private pin: Subject<string> = new BehaviorSubject<string>("");
  private card: Subject<string> = new BehaviorSubject<string>("");
  private game: Subject<string> = new BehaviorSubject<string>("");
  private validateResp: Subject<any> = new BehaviorSubject<any>({} as any);
  private denomination: Subject<any> = new BehaviorSubject<any>('');
  private result: Subject<any> = new BehaviorSubject<any>("");
  private fee: Subject<any> = new BehaviorSubject<any>("");
  private vat: Subject<any> = new BehaviorSubject<any>("");
  private isEnter: Subject<any> = new Subject<boolean>();
  private isDisabled: Subject<any> = new Subject<boolean>();
  //deposit page next button
  private allowCancel: Subject<any> = new Subject<boolean>();
  private allowSubmit: Subject<any> = new Subject<boolean>();

  get getallowCancel$() {
    return this.allowCancel.asObservable();
  }
  get getallowSubmit$() {
    return this.allowSubmit.asObservable();
  }

  updateallowCancel(data: boolean) {
    this.allowCancel.next(data);
  }
  updateallowSubmit(data: boolean) {
    this.allowSubmit.next(data);
  }

  get checkDark$() {
    return this.isDark.asObservable();
  }
  get getPage$() {
    return this.page.asObservable();
  }
  get checkIfResetPin$() {
    return this.reset.asObservable();
  }
  get getPin$() {
    return this.pin.asObservable();
  }
  get getCard$() {
    return this.card.asObservable();
  }
  get getGame$() {
    return this.game.asObservable();
  }
  get getValidateResponse$() {
    return this.validateResp.asObservable();
  }
  get getDenomination$() {
    return this.denomination.asObservable();
  }
  get getCategory$() {
    return this.category.asObservable();
  }
  get getResult$() {
    return this.result.asObservable();
  }
  get getFee$() {
    return this.fee.asObservable();
  }
  get getVat$() {
    return this.vat.asObservable();
  }
  get getEnter$() {
    return this.isEnter.asObservable();
  }
  updateClass(data: boolean) {
    this.isDark.next(data);
  }
  updatePage(data: string) {
    this.page.next(data);
  }
  setResetPin(data: boolean) {
    this.reset.next(data);
  }
  updatePin(data: string) {
    this.pin.next(data);
  }
  updateCard(data: string) {
    this.card.next(data);
  }
  updateGame(data: string) {
    this.game.next(data);
  }
  updateValidateResponse(data: any) {
    this.validateResp.next(data);
  }
  updateDenomination(data: any) {
    this.denomination.next(data);
  }
  updateCategory(data: any) {
    this.category.next(data);
  }
  updateResult(data: any) {
    this.result.next(data);
  }
  updateFee(data: any) {
    this.fee.next(data);
  }
  updateVat(data: any) {
    this.vat.next(data);
  }
  updateEnter(data: boolean) {
    this.isEnter.next(data);
  }
  updateAllowCancel(data: any) {
    this.allowCancel.next(data);
  }

  updateButtonDisable(data: boolean) {
    this.isDisabled.next(data);
  }

  getGamingHouses() {
    let session = this.storage.get('user.SessionID')
    return this.api.post(GAMING_ENDPOINTS.GAMING_HOUSES, { session }).then((response) => {
      let houses = response.data.filter((item) => {
        return item.status_kiosk == "ACTIVE"
      })
      houses.sort((a, b) => {
        return a.code == "IL" ? -1 : Number(a.id) - Number(b.id)
      })
      return houses.map((game) => {
        return {
          ...game,
          has_pin: game.is_pin_required == "YES",
          pin_digit: ["PG", "UG", "IL"].indexOf(game.code) >= 0 ? 6 : 4,
          hasWithdraw: ["IL", "UG"].indexOf(game.code) === -1,
          hasDeposit: true,
        } as ExtendedGamingHouse
      })
    }).catch((error) => {
      return []
    })
  }
}
